import React, { FC, useEffect, useState } from 'react';
import { Accordion } from '@ver-uds/uswds-react';
import { useLogout } from '@vis-auth/react';
import { useAccount } from '../../context/Account/AccountContext';
import CategoryInfo from './CategoryInfo/CategoryInfo';
import useResourceService from '../../services/ResourceService';
import { ResourceCategory } from '../../models/Resources';
import './ViewEssentialResources.scss';

const ViewEssentialResources: FC = () => {
  const [categories, setCategories] = useState<ResourceCategory[]>([]);
  const [error, setError] = useState<boolean>(false);

  const resourceService = useResourceService();
  const account = useAccount();
  const logout = useLogout();

  useEffect(() => {
    const fetchCategories = (): void => {
      resourceService
        .getCategories(account.type)
        .then(async (response) => {
          if (response.status === 401) {
            logout();
          } else {
            const data = await response.json();

            const temp = account.webServiceAccess.enabled
              ? data
              : data.filter((catagory: ResourceCategory) => catagory.title !== 'Web Services');

            setCategories(temp);
          }
        })
        .catch(() => {
          setError(true);
        });
    };

    if (categories.length === 0) {
      fetchCategories();
    }
  }, [resourceService, account, logout, categories]);

  function updateSubcategories(category: ResourceCategory): void {
    if (category.subCategories && !category.subCategoriesObject) {
      resourceService
        .getSubcategories(category.id, account.type)
        .then((data) => data.json())
        .then((data) => {
          setCategories(categories.map((c) => (c.id === category.id ? { ...c, subCategoriesObject: data } : c)));
        });
    }
  }

  if (error) {
    throw new Error('could not fetch categories');
  }

  return (
    <>
      <div className="section resources-section">
        <h1 data-testid="view-essential-resources" className="margin-0 padding-bottom-1">
          View Essential Resources
        </h1>
        <Accordion bordered multiple>
          {categories.map((category, index) => (
            <div key={category.id} className="resource-category">
              <Accordion.Heading controls={`a${index}`}>{category.title}</Accordion.Heading>
              <Accordion.Content id={`a${index}`} onOpen={(): void => updateSubcategories(category)}>
                {category.subCategories ? (
                  category.subCategoriesObject && <CategoryInfo key={category.id} category={category} />
                ) : (
                  <CategoryInfo key={category.id} category={category} />
                )}
              </Accordion.Content>
            </div>
          ))}
        </Accordion>
      </div>
    </>
  );
};

export default ViewEssentialResources;
